import React, { useState, useEffect } from "react";
import { Dialog, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
	messageMedia: {
		objectFit: "cover",
		width: 250,
		height: 200,
		display: "block",
		cursor: "pointer",
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
	},
	previewDialogPaper: {
		backgroundColor: "transparent",
		boxShadow: "none",
		maxWidth: "min(92vw, 1200px)",
		maxHeight: "92vh",
		overflow: "hidden",
	},
	previewImage: {
		display: "block",
		maxWidth: "92vw",
		maxHeight: "92vh",
		width: "auto",
		height: "auto",
		objectFit: "contain",
		borderRadius: 12,
	},
}));

const ModalImageCors = ({ imageUrl }) => {
	const classes = useStyles();
	const [previewOpen, setPreviewOpen] = useState(false);
	const [resolvedImageUrl, setResolvedImageUrl] = useState(imageUrl || "");

	useEffect(() => {
		if (!imageUrl) {
			setResolvedImageUrl("");
			return undefined;
		}

		let active = true;
		let currentBlobUrl = "";

		setResolvedImageUrl(imageUrl);

		const preloadImage = async () => {
			try {
				await new Promise((resolve, reject) => {
					const image = new Image();
					image.onload = resolve;
					image.onerror = reject;
					image.src = imageUrl;
				});
				return;
			} catch (_imageError) {
				try {
					const response = await fetch(imageUrl, {
						credentials: "include",
					});

					if (!response.ok) {
						throw new Error("IMAGE_FETCH_FAILED");
					}

					const blob = await response.blob();
					currentBlobUrl = window.URL.createObjectURL(blob);

					if (!active) {
						window.URL.revokeObjectURL(currentBlobUrl);
						return;
					}

					setResolvedImageUrl(currentBlobUrl);
				} catch (_fetchError) {
					if (active) {
						setResolvedImageUrl(imageUrl);
					}
				}
			}
		};

		preloadImage();

		return () => {
			active = false;
			if (currentBlobUrl) {
				window.URL.revokeObjectURL(currentBlobUrl);
			}
		};
	}, [imageUrl]);

	return (
		<>
			<img
				className={classes.messageMedia}
				src={resolvedImageUrl || imageUrl}
				alt="image"
				loading="lazy"
				onClick={() => setPreviewOpen(true)}
			/>
			<Dialog
				open={previewOpen}
				onClose={() => setPreviewOpen(false)}
				maxWidth={false}
				PaperProps={{ className: classes.previewDialogPaper }}
			>
				<img
					className={classes.previewImage}
					src={resolvedImageUrl || imageUrl}
					alt="image"
				/>
			</Dialog>
		</>
	);
};

export default ModalImageCors;
